exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr th[data-v-50ad8e00]{cursor:pointer;white-space:nowrap}table tr th span[data-v-50ad8e00]{display:inline-block;font-size:.8rem;color:#f0f0f0;margin:0 5px;transform:rotate(90deg)}table tr td[data-v-50ad8e00]:first-child,table tr th[data-v-50ad8e00]:first-child{text-align:left}button.add[data-v-50ad8e00]{background:#fff;border:2px solid #f0f0f0;font-size:2rem;line-height:2rem;padding:.5rem 2rem;color:#036}.cart[data-v-50ad8e00]{position:sticky;top:0;color:#036;font-weight:700;padding:0;display:flex;justify-content:space-around}.cart p[data-v-50ad8e00]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50ad8e00","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calc/Calories.vue
// module id = 176
// module chunks = 0